import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";
import { IRoundGetStateData } from "../interfaces";

@Injectable()
export class FetchCurrentRoundStateUseCase implements IUseCase<void, Promise<IRoundGetStateData>> {
    constructor(private roundRepository: RoundRepository) {
    }

    async execute(): Promise<IRoundGetStateData> {
        try {
            return await this.roundRepository.fetchCurrentRoundState();
        } catch (e) {
            throw e;
        }
    }
}
